import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import axios from 'axios'
import { LoadingState } from '../constants/Constants';
import { Teacher, TeacherData } from './viewmodels/TeacherViewModel';
import { Student } from './viewmodels/StudentViewModel';


const initialState: TeacherData = {
    teacher: {} as Teacher,
    loadingState: LoadingState.Idle,
    isAuthenticated: false,
}

export const fetchTeacher = createAsyncThunk('fetchTeacher', async (id: number) => {
    let URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/teacherdata/' + id + '/' : '/api/teacherdata/' + id + '/'
    const response = await axios.get(URL)
    return response.data as Teacher
})

export const createStudents = createAsyncThunk('createStudents', async ({ amountRequest, teacherId, group, task_access_list, active_item_sets }: { amountRequest: number, teacherId: number, group: string, task_access_list: number[], active_item_sets: number[] }) => {
    let URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/bulkcreate/' : '/api/bulkcreate/'
    const response = await axios.post(URL, {
        amount: amountRequest,
        id: teacherId,
        group: group,
        task_access_list: task_access_list,
        active_item_sets: active_item_sets
    })
    return response.data
})

export const deleteStudent = createAsyncThunk('deleteStudent', async (id: number) => {
    let URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/students/' + id + '/' : '/api/students/' + id + '/'
    const response = await axios.delete(URL)
    return response.data
})

const teacherSlice = createSlice({
    name: 'teacher',
    initialState,
    reducers: {
        teacherAuthStateSwap: (state, action: PayloadAction<boolean>) => {
            state.isAuthenticated = action.payload
        },
        modifyStudentInfo: (state, action: PayloadAction<Student>) => {
            const chosenStudent: Student | undefined = state.teacher.students.find(student => student.id === action.payload.id)
            if (chosenStudent) {
                chosenStudent.group = action.payload.group
                chosenStudent.task_access_list = action.payload.task_access_list
                chosenStudent.identification = action.payload.identification
                chosenStudent.active_item_sets = action.payload.active_item_sets
            }
        },
        removeStudentFromState: (state, action: PayloadAction<number>) => {
            state.teacher.students = state.teacher.students.filter(student => student.id !== action.payload)
        },
        clearTeacherState: (state) => {
            state.loadingState = initialState.loadingState
            state.teacher = initialState.teacher
            state.isAuthenticated = initialState.isAuthenticated
        }
    },
    extraReducers:
        (builder) => {
            builder.addCase(fetchTeacher.pending, (state) => {
                state.loadingState = LoadingState.Loading
            })
            builder.addCase(fetchTeacher.fulfilled, (state, action) => {
                state.loadingState = LoadingState.Idle
                state.teacher = action.payload
            })
            builder.addCase(createStudents.fulfilled, (state, action) => {
                state.teacher.students = state.teacher.students.concat(action.payload)
            })
        },
})

export const {
    actions: { teacherAuthStateSwap, modifyStudentInfo, removeStudentFromState, clearTeacherState },
} = teacherSlice;

export default teacherSlice.reducer